import $ from 'jquery';

export function disableButton(button) {
  $(button).attr('disabled', true).text($(this).attr('disable_with'));
}

export function enableButton(button) {
  $(button).attr('disabled', false).text($(this).attr('btn_text'));
}
